import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { benDataTransformer, capitalizeFirstLetter, errorFormate, payloadBuilderForObject } from "../../utils/helper";
import { changeDateFormate } from "../../utils/calculateAge";
import { ticketUpdateStatusSuccess } from "../../redux/ticketUpdateSlice/ticketUpdateSlice";
import { getBenByCompanyAndBenName, getBeneficiaryData, getBeneficiaryDataByMobile } from "../../pages/actions/actions";
import { ShowAlert } from "../../utils/showAlert";
import { UseGetStoreData } from "../getStoreData/UseGetStoreData";

export const useBeneficiaryData = () => {
  const dispatch = useDispatch()
  const benData = useSelector((state: any) => state?.beneficiary?.benData);
  const [selectedSearchOption, setSelectedSearchOption] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedOptionSearchRes, setSelectedOptionSearchRes] = useState("");
  const [searchByMobileRes, setSearchByMobileRes] = useState([])
  const [searchBenRes, setSearchBenRes] = useState<any[]>([]);
  const [benOptions, setBenOptions] = useState<any>([]);
  const [searchRes, setSearchRes] = useState<boolean>(false);
  const { getTicketUpdateData } = UseGetStoreData();

  const handleOptionChange = (event: any) => {
    setSelectedOption(event.target.value);
    setSelectedOptionSearchRes("");
    const benIdSplit = event.target.value.split(",");
    findSelectedPatient({ benId: benIdSplit[1], benList: benData })
  };
  //search by number or company changes//
  const handleSearchResChange = async (event: any) => {
    setSelectedOption("");
    setSelectedOptionSearchRes(event.target.value);
    const subscriberId = event.target.value.split(",");
    let action = "updateTicket";
    await getBeneficiaryData(subscriberId[0], dispatch, action);
    findSelectedPatient({ benId: subscriberId[1], benList: searchBenRes });
  };
  const findSelectedPatient = ({ benId, benList }: any) => {
    const selectedBen = benList.find((ben: any) => ben._id === benId);
    // console.log('selectedBen:', selectedBen)
    buildPatientPayload(selectedBen);
  };
  const transformEmergencyContact = (emContact: any) => {
    return emContact.reduce((emArr: any, data: any) => {
      emArr.push({
        fullName: data.fullName,
        mobile: data?.mobile?.number?.toString(),
        ...(data?.whatsappMobile?.number && {
          whatsappNumber: data.whatsappMobile.number.toString(),
        }),
      });
      return emArr;
    }, []);
  };

  const buildPatientPayload = (selectedBen: any) => {
    const fields = [
      "fullName",
      "gender",
      "mobile",
      "whatsappMobile",
      "email",
      "dateOfBirth",
      "languages",
    ];
    const getPatientPartialPayload = payloadBuilderForObject({
      fields,
      obj: selectedBen.personalInfo,
    });

    let patientPayload = {
      ...getPatientPartialPayload,
      mobile: getPatientPartialPayload?.mobile?.number?.toString(),
      whatsappNumber: getPatientPartialPayload?.whatsappMobile?.number?.toString(),
      address: selectedBen?.address || [],
      id: selectedBen._id,
      ...(getPatientPartialPayload?.gender
        ? { sex: capitalizeFirstLetter(getPatientPartialPayload?.gender) }
        : {}),
      mobilityStatus: selectedBen?.medicalInfo?.generalInfo?.mobilityStatus || "N/A",
      emergencyContacts: transformEmergencyContact(
        selectedBen.emergencyContacts || []
      ),
      ...(getPatientPartialPayload?.dateOfBirth
        ? { age: changeDateFormate(getPatientPartialPayload?.dateOfBirth) }
        : { age: "N/A" }),
    };
    delete patientPayload.gender;
    delete patientPayload.dateOfBirth;
    dispatch(ticketUpdateStatusSuccess({ patient: patientPayload }));
  };
  const handleSearchOptionChange = (event: any) => {
    setSelectedSearchOption(event.target.value);
    handleClearBenData();
  };


  const benFindOptions = [
    {
      value: "By Mobile Number",
      label: "By Mobile Number",
    },
    {
      value: "ByCompanyName",
      label: "By Company Name & Beneficiary Name",
    },
  ];
  const handleSearchByMobile = async (mobileNumber: string) => {
    setSearchRes(true);
    try {
      const searchPhoneNumber = await getBeneficiaryDataByMobile(mobileNumber, dispatch);
      setSearchBenRes(searchPhoneNumber);
      let res = benDataTransformer(searchPhoneNumber);
      setSearchByMobileRes(res);
      setSelectedOption("");
      setSearchRes(false);
    } catch (error: any) {
      setSearchRes(false);
      ShowAlert("warning", errorFormate({ e: error, service: "get ben By Mobile" }),

      );
      setSearchBenRes([]);
      setSearchByMobileRes([]);
    }
  }

  const handleSearchByCompany = async (benName: string, companyId: string) => {
    const payload = {
      benName,
      companyId
    };
    try {
      const getBenData = await getBenByCompanyAndBenName(payload);
      if (getBenData.length) {
        setSearchBenRes(getBenData);
        let res = benDataTransformer(getBenData);
        setSearchByMobileRes(res);
      }
    } catch (e) {
      ShowAlert("warning", errorFormate({ e: e, service: "get ben By Company" }));
      setSearchBenRes([]);
      setSearchByMobileRes([])
    }
  }

  const handleClearBenData = () => {
    setSearchBenRes([]);
    setSearchByMobileRes([]);
  };

  useEffect(() => {
    const benOptions = benDataTransformer(benData);
    setBenOptions(benOptions);
    if (getTicketUpdateData?.patient?.id) {
      const isBenSelected = benOptions.find((ben: any) => ben.label === getTicketUpdateData?.patient?.fullName);
      if (isBenSelected) {
        setSelectedOption(isBenSelected.value);
      }
    }
  }, [benData, getTicketUpdateData?.patient?.id, getTicketUpdateData?.patient?.fullName])

  return {
    benOptions,
    benFindOptions,
    selectedOption,
    handleOptionChange,
    handleSearchOptionChange,
    selectedSearchOption,
    handleSearchByMobile,
    searchBenRes,
    handleSearchResChange,
    selectedOptionSearchRes,
    searchByMobileRes,
    handleSearchByCompany,
    handleClearBenData,
    searchRes
  };
};
